import { BF2GetConfigBasedBuildingCallout } from "./BF2BuildingGraphicsUtils";
export var BF2GetBuildingCalloutsIso = function (data, selected) {
    if (data && data.balancing && !selected) {
        return BF2GetConfigBasedBuildingCallout(data);
    }
    return undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/BF2GetBuildingCalloutsIso.ts
// module id = 2210
// module chunks = 3